import React, { useEffect } from "react";
import {
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useLocation } from "react-router-dom";
import {
  createTourAddons,
  getTourAddonsByTourID,
} from "../services/tour.services";
import { clearTourAddonDetails } from "../tourSlice";
import { closeDialog } from "../../../components/dialog/dialogSlice";
import ShadowCard from "../../../components/common/ShadowCard";
import TourAddonArray from "./TourAddonArray";
import { Typography } from "@progress/kendo-react-common";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const TourAddonChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const TourAddonDetails = useAppSelector(
    (state) => state.tour.TourAddonDetails
  );

  useEffect(() => {
    const tourAddonsCopy = JSON.parse(JSON.stringify(TourAddonDetails))?.map(
      (tourDate: any) => ({
        ...tourDate,
      })
    );
    formRenderProps.onChange("TourAddOnCost", {
      value: tourAddonsCopy || [],
    });
  }, [TourAddonDetails]);
  return null;
};

const TourAddons: React.FC = () => {
  const location = useLocation();
  const TourID = location.state?.TourID;
  const dispatch = useAppDispatch();
  //   const AddonsLoading = useAppSelector((state) => state.tour.AddonsLoading);
  const TourAddonDetails = useAppSelector(
    (state) => state.tour.TourAddonDetails
  );

  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(clearTourAddonDetails());
    };
  }, []);

  useEffect(() => {
    if (TourID) {
      dispatch(getTourAddonsByTourID(TourID));
    }
  }, [TourID]);

  const handleSubmit = async (values: any) => {
    if (TourID) {
      const insertPayload = {
        TourAddOnCost: values.TourAddOnCost
          ? values.TourAddOnCost.map((tourDate: any) => {
              return {
                ID: tourDate.ID ? tourDate.ID : 0,
                Title: tourDate?.Title ? tourDate?.Title : "",
                ShortDescription: tourDate?.ShortDescription
                  ? tourDate?.ShortDescription
                  : "",
                Amount: tourDate?.Amount ? +tourDate?.Amount : null,
              };
            })
          : [],
        TourID: TourID,
      };
      const response = await dispatch(createTourAddons(insertPayload));
      if (response?.meta?.requestStatus === "fulfilled") {
        if (TourID) {
          dispatch(getTourAddonsByTourID(TourID));
        }
      }
    }
  };
  return (
    <>
      <Form
        onSubmit={handleSubmit}
        initialValues={TourAddonDetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <TourAddonChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12, marginTop: 20 }}>
              <GridLayout
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "100%" }]}
              >
                <GridLayoutItem>
                  <Typography.h4>{"Tour Addons"}</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem style={{ marginTop: 10 }}>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={TourAddonArray}
                    name="TourAddOnCost"
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: 10,
                    width: "100%",
                  }}
                >
                  <RippleButton
                    type="button"
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginRight: 10 }}
                    onClick={() => dispatch(decreaseActiveStep())}
                  >
                    Previous
                  </RippleButton>
                  <ButtonWithLoading
                    label={"Save"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || AddonsLoading}
                    loading={AddonsLoading}
                  />
                </GridLayoutItem> */}
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default TourAddons;
